import { caption } from '../../styles/commonStyles';
import ExistingTagsItemBase from './existingTagsItemBase';
import Box from '@mui/material/Box';

const ExistingTagsNoItems: React.FunctionComponent = () => {
	return (
		<ExistingTagsItemBase data-test-id="available-tags-not-found">
			<Box sx={caption}>{localize('No items found')}</Box>
		</ExistingTagsItemBase>
	);
};

export default ExistingTagsNoItems;
